module.exports = "<div class=\"grid grid--bleed grid--align-center footer-component\">\n  <div class=\"grid__col-12\">\n  </div>\n</div>\n";